module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-cebrity-hero-118ef297e0647c03ec8e9639425211eb.png";